// extracted by mini-css-extract-plugin
export default {"lazyLoadWrapper":"_e83fcd94","figureWrapper":"_13f86bf6","figureDescription":"_1ab59ca3","mainPhoto":"_cfe61f48","large":"_b62d9092","medium":"_813f0752","small":"_bfef2530"};